"use strict";
/**
 * @author OPt
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checks whether the given date is future date or not.
 */


var DateTodayFutureValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(DateTodayFutureValidator, _Validator_1$Validato);

  function DateTodayFutureValidator() {
    var _this;

    var todayIncluded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var fullValid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, DateTodayFutureValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateTodayFutureValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.todayIncluded = todayIncluded;
    _this.fullValid = fullValid;
    return _this;
  }

  _createClass(DateTodayFutureValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (!moment.isMoment(value)) {
        return new ValidationResult_1.ValidationError(DateTodayFutureValidator.DATE_INVALID_FORMAT);
      }

      if (this.fullValid && this.todayIncluded && value.isSameOrAfter(moment()) || value.isAfter(moment()) || this.todayIncluded && value.isSameOrAfter(moment(), 'day') || value.isAfter(moment(), 'day')) {
        return new ValidationResult_1.ValidationSuccess(value);
      }

      return new ValidationResult_1.ValidationError(DateTodayFutureValidator.DATE_NOT_FUTURE_ERROR);
    }
  }]);

  return DateTodayFutureValidator;
}(Validator_1.Validator);

exports.DateTodayFutureValidator = DateTodayFutureValidator;
DateTodayFutureValidator.DATE_INVALID_FORMAT = 'BAD_DATE_INVALID_FORMAT';
DateTodayFutureValidator.DATE_NOT_FUTURE_ERROR = 'DATE_NOT_FUTURE';